/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.59"
        height="88.6"
        viewBox="0 0 95.59 88.6"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M7.63 52.59a1.25 1.25 0 0 1 1.53.89 40.21 40.21 0 0 0 18 23.91 1.252 1.252 0 1 1-1.3 2.14A42.74 42.74 0 0 1 6.74 54.12a1.26 1.26 0 0 1 .89-1.53ZM86.18 53.77a1.25 1.25 0 0 1 2.41.66 42.21 42.21 0 0 1-19.21 25.24 1.251 1.251 0 1 1-1.28-2.15 39.72 39.72 0 0 0 18.08-23.75ZM47.71 0a42.1 42.1 0 0 1 24.26 7.63 1.25 1.25 0 0 1-1.44 2 39.87 39.87 0 0 0-45.65 0 1.25 1.25 0 0 1-1.43-2A42.1 42.1 0 0 1 47.71 0Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M13.97 16.42a7.85 7.85 0 1 0 7.84 7.84 7.84 7.84 0 0 0-7.84-7.84Zm0 2.5a5.35 5.35 0 1 1-5.35 5.34 5.34 5.34 0 0 1 5.35-5.34ZM20.43 35.14a7.51 7.51 0 0 1 7.5 7.25v1.18a1.25 1.25 0 0 1-2.49.12v-1a5 5 0 0 0-4.78-5H7.5a5 5 0 0 0-5 4.78v1.15a1.25 1.25 0 0 1-2.49.12v-1a7.51 7.51 0 0 1 7.25-7.5h13.17ZM81.62 16.42a7.85 7.85 0 1 0 7.88 7.84 7.84 7.84 0 0 0-7.88-7.84Zm0 2.5a5.35 5.35 0 1 1-5.34 5.34 5.34 5.34 0 0 1 5.34-5.34ZM88.09 35.14a7.5 7.5 0 0 1 7.49 7.25v1.18a1.24 1.24 0 0 1-1.25 1.25 1.26 1.26 0 0 1-1.24-1.13v-1a5 5 0 0 0-4.78-5H75.15a5 5 0 0 0-5 4.78v1.15a1.24 1.24 0 0 1-1.25 1.25 1.26 1.26 0 0 1-1.24-1.13v-1a7.51 7.51 0 0 1 7.26-7.5H88.1ZM47.6 60.2a7.85 7.85 0 1 0 7.84 7.8 7.85 7.85 0 0 0-7.84-7.8Zm0 2.5a5.35 5.35 0 1 1-5.35 5.3 5.34 5.34 0 0 1 5.35-5.3ZM54.07 78.92a7.5 7.5 0 0 1 7.49 7.25v1.18a1.25 1.25 0 0 1-2.49.12v-1a5 5 0 0 0-4.78-5H41.13a5 5 0 0 0-5 4.78v1.15a1.25 1.25 0 0 1-2.49.12v-1a7.51 7.51 0 0 1 7.26-7.5h13.17Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ThreePeopleConnectedByOuterLinesIcon';

export default Icon;
